export const CUSTOM_FREE_TEXT_KEY = 'free_text'
export const CUSTOM_FREE_TEXT_PREFIX = `${CUSTOM_FREE_TEXT_KEY}_`
export const MAX_CUSTOM_APPLICATION_QUESTIONS = 10

export function isCustomFreeTextQuestionKey(key) {
  return (
    key === CUSTOM_FREE_TEXT_KEY ||
    (typeof key === 'string' && key.startsWith(CUSTOM_FREE_TEXT_PREFIX))
  )
}

export function createCustomFreeTextQuestionKey(existingQuestions = {}) {
  const questions = existingQuestions || {}
  if (!questions[CUSTOM_FREE_TEXT_KEY]) return CUSTOM_FREE_TEXT_KEY

  const id =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}_${Math.random().toString(36).slice(2)}`

  return `${CUSTOM_FREE_TEXT_PREFIX}${id}`
}

export function getCustomFreeTextQuestionCount(questions = {}) {
  return Object.keys(questions || {}).filter(isCustomFreeTextQuestionKey).length
}
